import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useHistory,Link} from "react-router-dom"
import {Card,Descriptions,Image, message,Typography, Space} from "antd"
import CenterService from "./../../../services/CenterService"
import { ConvertToImage } from "../../../utils/ConvertToFile";
import ModalEditData from "../../Layouts/ModelEditData/ModalEditData";
import { EditOutlined } from '@ant-design/icons';

const{Meta}=Card;
const {Text}=Typography

export default function CenterData(params) {
    const {Body,updateLogoByCenter,CenterLogo,defaultLogo}=params
    const [centerData,setCenterData]=useState({})
    const [CenterAcademicUnit,setCenterAcademicUnit]=useState({})
    const [centerCampus,setCenterCampus]=useState({})
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(search),[search]
      );
    const [logoCenter,setLogoCenter]=useState()
    const [showModal,setShowModal]=useState(false)
    const actionCenter=[
        <Space >
            <Link onClick={()=>(setShowModal(true))} >
                <EditOutlined 
                key="editLogoCenter" 
                />
                <Text> Actualizar el logo</Text>
            </Link>
        </Space>
    ]
    const hideModal=(option)=>{
        setShowModal(option)
    }

    const updateLogo=(file)=>{
        updateLogoCenter(centerData.id,file)
    }

    const optionsModal={
        open: showModal,
        onCancel:hideModal,
        onUpdateLogo:updateLogo,
    }
    const updateLogoCenter=useCallback((centerID,fileList)=>{
        console.log("f",fileList.length)
        const formData = new FormData();
        formData.append("logoCenter","");   
        if(fileList.length>=1)
        {
            let file=fileList[0]
            const blobFile = new Blob([file.originFileObj] , { type: file.type });
            formData.set("logoCenter",blobFile,file.name);
            // console.log("formData",formData.get("logoCenter"))
            CenterService.updateLogoByCenter(formData,centerID).then((res)=>{
                let {success,response}=res?.data
                if(success){
                    console.log("res",response)
                    updateLogoByCenter(true)
                    message.success("Se actualizo exitosamente el logo del centro") 
                }else{
                    message.error("Ocurrio un problema al actualizar el logo")
                }
            })
        }
        else{
            message.info("No se tiene imagenes para enviar")
        }
        
    })

    const changeLogoCenter=()=>{
        // console.log("Body",Body)
        // console.log("CenterLogo",CenterLogo)
        if(CenterLogo?.logoCenter!=null){
            // let base64String;
            // const buf = Buffer.from(centerSession.logoCenter);
            // const blob = new Blob([buf],{type: "image/png"});
            // const myFile=new File([blob],'image.png', {
            //     type: blob.type,
            // })
            // const reader = new FileReader();
            // reader.readAsDataURL(myFile);
            // reader.onloadend = function () { 
            // base64String = reader.result; 
            // console.log('Base64 String - ', base64String);
            // // console.log('Base64 String without Tags- ',  
            // // base64String.substr(base64String.indexOf(', ') + 1)); 
            // setLogoCenter(base64String)     
            // }  
            // let vaar=centerSession.logoCenter
            // console.log(`${vaar}`) 
            // const base64String = btoa(String.fromCharCode(...new Uint8Array(vaar)));
            // console.log(`data:image/png;base64,${base64String}`) 
            // console.log('Base64 String - ', reader.result);
            ConvertToImage(CenterLogo?.logoCenter).then(res=>setLogoCenter(res))
            //setLogoCenter(ConvertToImage(CenterLogo?.logoCenter))
        }
        else{
            setLogoCenter(defaultLogo)
        }
    }

    useEffect(()=>{
        setCenterData(Body);
        setCenterCampus(centerData.Campus);
        setCenterAcademicUnit(centerData.AcademicUnit);
        changeLogoCenter()
        if (searchParams.get('option')!=="dataCenter") {
            searchParams.set('option', 'dataCenter');
            history.replace({ search: searchParams.toString() });
        }
        

    },[setCenterData,setCenterCampus,setCenterAcademicUnit,changeLogoCenter])

    useEffect(()=>{
        changeLogoCenter()
    },[CenterLogo])

    const convertDateToOnlyDate=(date)=> {
        const newDate=new Date(date);
        return newDate.toLocaleDateString();
    }
    function convertDateToTime(date) {
        const newDate=new Date(date);
        return newDate.toLocaleTimeString();
    }

    return(
        <>
        <Card 
        bordered={false}
        style={{backgroundColor:"whitesmoke"}}
        cover={ <Image className="ImageBackgroundCard" src={logoCenter}></Image>}
        actions={actionCenter }
        >
            <Card>
                <Meta className="titleCard" title={centerData.name}/>
            </Card>
            <Card>
                <Descriptions
                bordered
                >

                        <Descriptions.Item label="Nombre" span={3} >{centerData?.name} </Descriptions.Item >
                        <Descriptions.Item label="Acronimo" span={3} >{centerData?.acronym} </Descriptions.Item >
                        <Descriptions.Item label="Sede academica" span={3}>{centerCampus?.name}</Descriptions.Item>
                        <Descriptions.Item label="Unidad academica" span={3}>{CenterAcademicUnit?.name}</Descriptions.Item>
                        <Descriptions.Item label="Fecha de creacion"span={2}>{convertDateToOnlyDate(centerData?.createdAt)}</Descriptions.Item>
                        <Descriptions.Item label="Hora de creacion"span={1}>{convertDateToTime(centerData?.createdAt)}</Descriptions.Item>
                        <Descriptions.Item label="Fecha de actualización"span={2}>{convertDateToOnlyDate(centerData?.updatedAt)}</Descriptions.Item>
                        <Descriptions.Item label="Hora de actualización"span={1}>{convertDateToTime(centerData?.createdAt)}</Descriptions.Item>
                </Descriptions>
            </Card>
        </Card>
        <ModalEditData
        data={
            [{
                name: ["logoCenter"],
                value: logoCenter,
            }]
        }
        options={optionsModal}
        ></ModalEditData>
        </>
    )
}